import PermissionButton from '../../permissions/PermissionButton';
import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { useCreateEntrepot } from '../../hooks/entrepotHooks';
import { useNavigate } from 'react-router-dom';

const EntrepotForm = () => {
  const [form] = Form.useForm();
  const { create, loading } = useCreateEntrepot();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    try {
      await create(values);
      message.success('Entrepôt créé avec succès');
      form.resetFields();
      navigate('/entrepot');
    } catch (error) {
      message.error(error.response?.data?.message || error.message || 'Erreur lors de la création');
    }
  };

  return (
    <Card title="Créer un Entrepôt" bordered={false} style={{ width: '100%', maxWidth: 600 }}>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Code Entrepôt"
          name="code_ent"
          rules={[
            { required: true, message: 'Veuillez saisir le code entrepôt!' },
            { pattern: /^[A-Za-z0-9]+$/, message: 'Le code doit contenir uniquement des lettres et chiffres' }
          ]}
        >
          <Input placeholder="Ex: 1, 2, ENT1..." />
        </Form.Item>
        <Form.Item
          label="Nom"
          name="name"
          rules={[{ required: true, message: 'Veuillez saisir le nom!' }]}
        >
          <Input placeholder="Ex: Entrepôt Principal..." />
        </Form.Item>
        <Form.Item>
          <PermissionButton permissionModule="warehouses" permissionAction="create" type="primary" htmlType="submit" loading={loading}>
            Créer
          </PermissionButton>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate('/entrepot')}>
            Annuler
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default EntrepotForm;

